<div class="dialog-container">
    <div class="dialog-header">
        <h2 class="dialog-title">
            {{ 'unSavedLabelsTitle' | translate }}
        </h2>
    </div>
    <div class="dialog-body">
        <p class="dialog-message">
            {{ 'unSavedLabelsMessage' | translate }}
        </p>
    </div>
    <div class="dialog-actions">
        <button mat-raised-button color="accent" (click)="onCancel()">
            {{'No'|translate}}
        </button>
        <button mat-raised-button color="primary" (click)="onConfirm()">
            {{'Yes'|translate}}
        </button>
    </div>
</div>